import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import { takeEvery, call, put } from "redux-saga/effects";
import { 
  FETCH_CALL_MEETING_REQUEST,
  FETCHING_CALL_MEETING_SUCCEEDED,
  FETCHING_CALL_MEETING_FAILED,
  FETCH_CALL_MEETINGS_REQUEST,
  FETCHING_CALL_MEETINGS_SUCCEEDED,
  FETCHING_CALL_MEETINGS_FAILED,
  INVALIDATE_CALL_MEETING,
  UPLOAD_CALL_RECORDING_REQUEST,
  UPLOAD_CALL_RECORDING_SUCCEEDED,
  UPLOAD_CALL_RECORDING_FAILED,
  DELETE_UPLOAD_CALL_RECORDING_REQUEST,
  DELETING_UPLOAD_CALL_RECORDING_SUCCEEDED,
  DELETING_UPLOAD_CALL_RECORDING_FAILED,
  INVALIDATE_UPLOAD_CALL_RECORDING,
  FETCH_UPLOAD_CALL_MEETINGS_REQUEST,
  FETCHING_UPLOAD_CALL_MEETINGS_SUCCEEDED,
  FETCHING_UPLOAD_CALL_MEETINGS_FAILED

} from "../actionTypes";
import { FetchCallMettingRequest, FetchCallMettingResponse, FetchCallMettingErrorResponse,
    FetchCallMettingsRequest, FetchCallMettingsResponse, FetchCallMettingsErrorResponse,
    UploadCallRecordingRequest,UploadCallRecordingResponse,UploadCallRecordingErrorResponse,
    DeleteUploadCallRecordingRequest,DeleteUploadCallRecordingResponse,DeleteUploadCallRecordingErrorResponse,
    FetchUploadCallMeetingsRequest, FetchUploadCallMeetingsResponse, FetchUploadCallMeetingsErrorResponse
} from "src/types/coaching/callLibrary";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_COACHING_API_URL}`;

// fetch call recording
export const fetchCallMeeting = createAction<FetchCallMettingRequest>(FETCH_CALL_MEETING_REQUEST);
const fetchingCallMeetingSucceeded = createAction<FetchCallMettingResponse>(FETCHING_CALL_MEETING_SUCCEEDED);
const fetchingCallMeetingFailed = createAction<FetchCallMettingErrorResponse>(FETCHING_CALL_MEETING_FAILED);

const fetchCallMeetingSaga = function* (action: ReturnType<typeof fetchCallMeeting>): any {
  const { id } = action.payload as FetchCallMettingRequest;
  const url = `${apiUrl}/api/1.0/call_meetings/${id}`;

  const fetchCallMeetingApi = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCallMeetingApi);
    yield put(fetchingCallMeetingSucceeded({id: id, response}));
  } catch (error) {
    yield put(fetchingCallMeetingFailed({id: id, error }));
  }
};
    

// fetch call recordings
export const fetchCallMeetings = createAction<FetchCallMettingsRequest>(FETCH_CALL_MEETINGS_REQUEST);
const fetchCallMeetingsSucceeded = createAction<FetchCallMettingsResponse>(FETCHING_CALL_MEETINGS_SUCCEEDED);
const fetchCallMeetingsFailed = createAction<FetchCallMettingsErrorResponse>(FETCHING_CALL_MEETINGS_FAILED);

const fetchCallMeetingsSaga = function* (action: ReturnType<typeof fetchCallMeetings>): any {
  const { page, limit  } = action.payload as FetchCallMettingsRequest;

  const url = `${apiUrl}/api/1.0/call_meetings`;

  const fetchCallMeetingsApi = () => {
    return axios({
      method: "GET",
      url: url,
      params: {
        page: page,
        limit: limit,
      },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCallMeetingsApi);
    yield put(fetchCallMeetingsSucceeded({response: response}));
  } catch (error) {
    yield put(fetchCallMeetingsFailed({error}));
  }
};

export const invalidateCallMeeting = createAction<void>(INVALIDATE_CALL_MEETING);

// fetch transcript for call recording
export const uploadCallRecording = createAction<UploadCallRecordingRequest>(UPLOAD_CALL_RECORDING_REQUEST);
const uploadrCallRecordingSucceeded = createAction<UploadCallRecordingResponse>(UPLOAD_CALL_RECORDING_SUCCEEDED);
const uploadCallRecordingFailed = createAction<UploadCallRecordingErrorResponse>(UPLOAD_CALL_RECORDING_FAILED);

const uploadCallRecordingSaga = function* (action: ReturnType<typeof uploadCallRecording>): any {
  const { id, signedUrl } = action.payload;

  const uploadCallRecordingAPI = () => {
    return axios({
      method: "POST",
      url: `${apiUrl}/api/1.0/call_meetings/upload`,
      data: {
        signedUrl: signedUrl,   
        id: id
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(uploadCallRecordingAPI);
    yield put(
      uploadrCallRecordingSucceeded({
        id: response.id,
        response: response,
      }),
    );
  } catch (error) {
    yield put(uploadCallRecordingFailed({ id: id, error: error }));
  }
};

export const deleteUploadCallRecording = createAction<DeleteUploadCallRecordingRequest>(DELETE_UPLOAD_CALL_RECORDING_REQUEST);
const deletingUploadCallRecordingSucceeded = createAction<DeleteUploadCallRecordingResponse>(DELETING_UPLOAD_CALL_RECORDING_SUCCEEDED);
const deletingUploadCallRecordingFailed = createAction<DeleteUploadCallRecordingErrorResponse>(DELETING_UPLOAD_CALL_RECORDING_FAILED);

const deleteUploadCallRecordingSaga = function* (action: ReturnType<typeof deleteUploadCallRecording>): any {
  const { id } = action.payload;

  const deleteCallRecordingApi = () => {
    return axios({
      method: "DELETE",
      url: `${apiUrl}/api/1.0/call_meetings/${id}`
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteCallRecordingApi);
    yield put(deletingUploadCallRecordingSucceeded(response));
  } catch (error) {
    yield put(deletingUploadCallRecordingFailed({ id: id, error: error }));
  }
};

export const invalidateUploadCallRecording = createAction<void>(INVALIDATE_UPLOAD_CALL_RECORDING);

export const fetchUploadCallMeetings = createAction<FetchUploadCallMeetingsRequest>(FETCH_UPLOAD_CALL_MEETINGS_REQUEST);
const fetchingUploadCallMeetingsSucceeded = createAction<FetchUploadCallMeetingsResponse>(FETCHING_UPLOAD_CALL_MEETINGS_SUCCEEDED);
const fetchingUploadCallMeetingsFailed = createAction<FetchUploadCallMeetingsErrorResponse>(FETCHING_UPLOAD_CALL_MEETINGS_FAILED);

const fetchUploadCallMeetingsSaga = function* (action: ReturnType<typeof fetchUploadCallMeetings>): any {
  const { page, limit } = action.payload as FetchUploadCallMeetingsRequest;
  const url = `${apiUrl}/api/1.0/call_meetings/calls`;

  const fetchUploadCallMeetingsApi = () => {
    return axios({
      method: "GET",
      url: url,
      params: {
        page: page,
        limit: limit,
      },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchUploadCallMeetingsApi);
    yield put(fetchingUploadCallMeetingsSucceeded({ response }));
  } catch (error) {
    yield put(fetchingUploadCallMeetingsFailed({ error }));
  }
};

export default function* callMeetingSaga() {
  yield takeEvery(FETCH_CALL_MEETING_REQUEST, fetchCallMeetingSaga);
  yield takeEvery(FETCH_CALL_MEETINGS_REQUEST, fetchCallMeetingsSaga);
  yield takeEvery(UPLOAD_CALL_RECORDING_REQUEST, uploadCallRecordingSaga)
  yield takeEvery(DELETE_UPLOAD_CALL_RECORDING_REQUEST, deleteUploadCallRecordingSaga)
  yield takeEvery(FETCH_UPLOAD_CALL_MEETINGS_REQUEST, fetchUploadCallMeetingsSaga)
}